@use "styles/variables" as *;

.axisTooltipIcon {
  display: flex;
  cursor: pointer;
}

.axisField {
  position: relative;
  margin-left: -33px;
  width: 110px;
}

.axisInputWrap {
  gap: 0;
  position: relative;

  :global(span) {
    position: absolute;
    top: 8px;
    left: -7px;
    z-index: 3;
    margin: 0;
    font-size: 12px;
    font-weight: 500;
    color: $infoColor;
    text-transform: none;
    letter-spacing: normal;
  }
}

.axisInput {
  height: 30px !important;
  padding: 0 15px 0 30px !important;
  font-size: 12px !important;
  font-weight: 500;
  border-radius: 0 !important;
  line-height: 16px !important;
}

.axisTip {
  font-size: 10px;
  position: absolute;
  bottom: 7px;
  right: 15px;
  color: $disabledColor;
  margin: 0;
  pointer-events: none;
  line-height: 16px;
}

.axle-load-wrapper {
  border-left: 1px solid #dae3eb;
  padding: 20px 0 20px 10px;
  @media (max-width: 1150px) {
    border-left: none;
    margin: 0 auto;
  }

  .axle-load-title-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    font-size: 12px;
    color: #9fb1c1;
    margin-bottom: 8px;
    & p {
      margin: 0;
    }
  }
  .axle-data-outer-wrapper {
    padding-left: 30px;
    border: 1px solid #ecf5fc;
    width: 255px;

    .axle-data-inner-wrapper {
      border: 1px solid #c6d3df;
      padding: 12px 8px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .axisField::after {
        content: "";
        display: block;
        position: absolute;
        border: 10px solid transparent;
        left: 15px;
      }

      .axisField:nth-child(1)::after,
      .axisField:nth-child(2)::after {
        border-top: 10px solid #15354e;
        top: -23px;
      }

      .axisField:nth-child(2)::after,
      .axisField:nth-child(4)::after {
        left: 70px;
      }

      .axisField:nth-child(3)::after,
      .axisField:nth-child(4)::after {
        border-bottom: 10px solid #15354e;
        bottom: -23px;
      }

      .axisField:first-child,
      .axisField:nth-child(2) {
        margin-bottom: 10px;
      }
    }
  }
}
